import script from "./TroubleContent.vue?vue&type=script&setup=true&lang=js"
export * from "./TroubleContent.vue?vue&type=script&setup=true&lang=js"

import "./TroubleContent.vue?vue&type=style&index=0&id=66e17f6e&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-66e17f6e"]])

export default __exports__